/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Информация о доступном действии в UI
 */
export interface ActionInfo {
  /** Название действия */
  name: string;

  /** Описание действия */
  desc: string;

  /** Признак доступности действия */
  isAvailable: boolean;
}

/**
 * Информация о внешнем платеже
 */
export interface PaymentInfo {
  /**
   * Номер платежки
   * @example 123456
   */
  number?: string;

  /**
   * Дата платежа
   * @example "2023-11-21T00:00:00.000Z"
   */
  date?: string;

  /**
   * БИК банка плательщика
   * @example 21
   */
  bankBIC?: string;

  /**
   * Название банка плательщика
   * @example 643
   */
  bankName?: string;

  /**
   * Номер счета
   * @example 410810416845546854
   */
  account?: string;

  /**
   * Назначение платежа
   * @example Зачисление денежных средств на счета сотрудников, указанных в реестре №  {registerDate} от {registerNumber} по договору {contractNumber} от {contractDate}. НДС не облагается.
   */
  ground?: string;
}

/**
 * Тип и версия документа для подписания
 */
export interface RegistryDocumentType {
  /** @example SALARY_TRANSFER_REGISTRY */
  documentType?: string;

  /** @example Реестр на зачисление ЗП */
  documentDesc?: string;

  /** @example 1.1 */
  documentVersion?: string;
}

/**
 * Информация об ошибках реестра
 */
export interface RegistryError {
  /**
   * Номер строки с ошибкой
   * @format int32
   * @example 2
   */
  line?: number;

  /**
   * Текст ошибки
   * @example Счет не существует
   */
  errorMessage?: string;
}

/**
 * Реестр на перечисление заработной платы
 */
export interface RegistryInfo {
  /** Тип и версия документа для подписания */
  documentType?: RegistryDocumentType;

  /**
   * Идентификатор реестра
   * @example 51a228b0-240b-4a88-995b-fd592d81fda2
   */
  id?: string;

  /**
   * Идентификатор клиента (ЮЛ) в АБС ЦФТ
   * @example 9894250
   */
  clientAbsId: string;

  /**
   * ИНН клиента (ЮЛ)
   * @example 7735989425
   */
  clientInn?: string;

  /**
   * Номер реестра
   * @example 5
   */
  registryNumber?: string;

  /**
   * Дата создания реестра
   * @example "2022-12-07T00:00:00.000Z"
   */
  registryDate: string;

  /**
   * Идентификатор ЗП договора в АБС ЦФТ
   * @example 9898494
   */
  contractAbsId: string;

  /**
   * Дата ЗП договора
   * @example "2022-12-07T00:00:00.000Z"
   */
  contractDate?: string;

  /**
   * Номер ЗП договора
   * @example 234100-3254
   */
  contractNumber?: string;

  /**
   * Статус реестра
   * @example PREPARED
   */
  status?: string;

  /**
   * Общая сумма реестра
   * @example 354686.23
   */
  totalSum: string;

  /**
   * Все сотрудники в реестре - резиденты РФ
   * @example true
   */
  resident?: boolean;

  /**
   * Количество строк на выплаты в реестре
   * @format int32
   * @example 23
   */
  employeeCount?: number;
  clientEmployee?: RegistryLineInfo[];

  /**
   * Хэш по ГОСТ Р 34.11-2012 256 от списка сотрудников в реестре.
   * @example P1OaIT6XyALMIp1HTGqjKoJaNgsqkzqUn9klII2c4bs=
   */
  clientEmployeeHash?: string[];

  /**
   * Идентификатор платежа по переводу ЗП
   * @example 719da9fc-8889-477a-89e3-10f7d8d957d4
   */
  salaryPaymentRef?: string;

  /**
   * Идентификатор платежа по оплате комиссии за перечисление ЗП
   * @example 719da9fc-8889-477a-89e4-10f7d8d957d4
   */
  commissionPaymentRef?: string;

  /** Информация о внешнем платеже */
  salaryExternalRef?: PaymentInfo;

  /** Информация о внешнем платеже */
  commissionExternalRef?: PaymentInfo;

  /** Список ошибок реестра */
  errorList?: RegistryError[];

  /** Доступные операции с реестром в UI */
  actions: ActionInfo[];
}

/**
 * Информация о получателе ЗП
 */
export interface RegistryLineInfo {
  /**
   * Внутренний дентификатор записи в реестре
   * @example 51a228b0-240b-4a88-995b-fd592d81fda2
   */
  id?: string;

  /**
   * Номер строки
   * @example 1
   */
  npp?: string;

  /**
   * ФИО сотрудника
   * @example Иванов Иван Иванович
   */
  fio: string;

  /**
   * Счет сотрудника для перечисления ЗП
   * @example 40810770345613278
   */
  account: string;

  /**
   * Код вида дохода
   * @example 1
   */
  incomeTypeCode: string;

  /**
   * Сумма ЗП
   * @example 33425.99
   */
  sum: string;

  /**
   * Сумма удержаний из ЗП сотрудника
   * @example 1365.25
   */
  paymentExecSum: string;
}

/**
 * Стандартный объект ошибки
 */
export interface DefaultExceptionResponse {
  /**
   * Тип проблемы. Внутренний тип ошибки микросервиса
   * @example A5478
   */
  type: string;

  /**
   * Описание логической ошибки, возникшей в процессе работы
   * @example Некорректный формат идентификатора ресурса
   */
  title: string;

  /**
   * Код состояния HTTP ( [RFC7231], раздел 6 ) созданный исходным сервером
   * @format int32
   * @example 400
   */
  status: number;

  /**
   * Удобочитаемое объяснение проблемы
   * @example Сотрудник 9146590 не найден
   */
  detail?: string;
}

export interface LocatorObject {
  location?: object;
  locatorString?: string;
}

/**
 * Результат конвертации файла
 */
export interface WageImportResult {
  /** Реестр на перечисление заработной платы */
  registryInfo?: RegistryInfo;
  remarks?: { empty?: boolean };
  currentLocator?: LocatorObject;
}

/**
 * Запись об одной смене статуса в истории реестра.
 */
export interface RegistryHistoryInfo {
  /**
   * Статус, в который перешёл реестр, в результате этого действия.
   * @example PREPARED
   */
  targetStatus?: string;

  /**
   * Описание события.
   * @example Переход в статус "Создан"
   */
  description?: string;

  /**
   * Пользователь, совершивший действие. Пусто, если событие автоматическое.
   * @example Перовская Софья Львовна
   */
  username?: string;

  /**
   * Дата смены статуса в iso формате.
   * @format date-time
   * @example 2023-12-19T09:46:11.706Z
   */
  changeDate?: string;
}

export interface RegistryHistoryList {
  data: RegistryHistoryInfo[];
}

export interface SlicedRegistryList {
  data: RegistryInfo[];
  hasMore?: boolean;

  /** @format int32 */
  lastUpdate?: number;
}

export interface ConfirmationTypeList {
  data: string[];
}

import { HttpClient } from "../../client";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title Зарплатный проект. Микросервис Реестры на зачисление ЗП
 * @version 1.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl https://owb-ms-prd-salary-transfer.ndbo.dev.rshbdev.ru
 * @contact https://sdlc.go.rshbank.ru/jira/projects/OB_WAGE <info@rshbintech.ru> (https://sdlc.go.rshbank.ru/confluence/pages/viewpage.action?pageId=85998056)
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * @description Редактирование реестра на перечисление зп
     *
     * @tags Реестр на перечисление зп
     * @name EditRegistry
     * @summary Сохранить изменения в реестре
     * @request PUT:/api/salary-transfer/external/v1/registry
     * @secure
     */
    editRegistry: (data: RegistryInfo, params: RequestParams = {}) =>
      this.request<RegistryInfo, DefaultExceptionResponse>({
        path: `/api/salary-transfer/external/v1/registry`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Создание нового реестра перечисление зп
     *
     * @tags Реестр на перечисление зп
     * @name NewRegistry
     * @summary Создать реестр
     * @request POST:/api/salary-transfer/external/v1/registry
     * @secure
     */
    newRegistry: (data: RegistryInfo, params: RequestParams = {}) =>
      this.request<RegistryInfo, DefaultExceptionResponse>({
        path: `/api/salary-transfer/external/v1/registry`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Создание нового реестра для корректировки
     *
     * @tags Реестр на перечисление зп
     * @name NewCorrectionRegistry
     * @summary Создать корректирующий реестр
     * @request POST:/api/salary-transfer/external/v1/registry/{registryId}/correction
     * @secure
     */
    newCorrectionRegistry: (
      registryId: string,
      data: RegistryInfo,
      params: RequestParams = {}
    ) =>
      this.request<RegistryInfo, DefaultExceptionResponse>({
        path: `/api/salary-transfer/external/v1/registry/${registryId}/correction`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Импорт реестра на перечисление зп
     *
     * @tags Реестр на перечисление зп, Импорт реестров на перечисление зп
     * @name ImportRegistry
     * @summary Импорт реестра из файла
     * @request POST:/api/salary-transfer/external/v1/registry/import
     * @secure
     */
    importRegistry: (data: { file: File }, params: RequestParams = {}) =>
      this.request<WageImportResult, DefaultExceptionResponse>({
        path: `/api/salary-transfer/external/v1/registry/import`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description Импорт реестров на перечисление зп
     *
     * @tags Реестр на перечисление зп, Импорт реестров на перечисление зп
     * @name MultiImportRegistry
     * @summary Импорт реестров из файла
     * @request POST:/api/salary-transfer/external/v1/contract/{contractAbsId}/registry/multi-import
     * @secure
     */
    multiImportRegistry: (
      contractAbsId: string,
      query: { file: File[] },
      params: RequestParams = {}
    ) =>
      this.request<WageImportResult[], DefaultExceptionResponse>({
        path: `/api/salary-transfer/external/v1/contract/${contractAbsId}/registry/multi-import`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Получение детальной информации о реестре на перечисление зп
     *
     * @tags Реестр на перечисление зп
     * @name GetRegistryById
     * @summary Получить реестр
     * @request GET:/api/salary-transfer/external/v1/registry/{registryId}
     * @secure
     */
    getRegistryById: (registryId: string, params: RequestParams = {}) =>
      this.request<RegistryInfo, DefaultExceptionResponse>({
        path: `/api/salary-transfer/external/v1/registry/${registryId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Удаление реестра на перечисление зп
     *
     * @tags Реестр на перечисление зп
     * @name DeleteRegistry
     * @summary Удалить реестр
     * @request DELETE:/api/salary-transfer/external/v1/registry/{registryId}
     * @secure
     */
    deleteRegistry: (registryId: string, params: RequestParams = {}) =>
      this.request<void, DefaultExceptionResponse>({
        path: `/api/salary-transfer/external/v1/registry/${registryId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Экспорт реестра на перечисление зарплаты
     *
     * @tags Реестр на перечисление зп, Экспорт реестров на перечисление зп
     * @name DownloadRegistryExcel
     * @summary Скачать реестр в формате XLS
     * @request GET:/api/salary-transfer/external/v1/registry/{registryId}/xls
     * @secure
     */
    downloadRegistryExcel: (registryId: string, params: RequestParams = {}) =>
      this.request<string, DefaultExceptionResponse>({
        path: `/api/salary-transfer/external/v1/registry/${registryId}/xls`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * @description Экспорт реестра на перечисление зарплаты
     *
     * @tags Реестр на перечисление зп, Экспорт реестров на перечисление зп
     * @name DownloadRegistryPdf
     * @summary Скачать реестр в формате PDF
     * @request GET:/api/salary-transfer/external/v1/registry/{registryId}/pdf
     * @secure
     */
    downloadRegistryPdf: (registryId: string, params: RequestParams = {}) =>
      this.request<string, DefaultExceptionResponse>({
        path: `/api/salary-transfer/external/v1/registry/${registryId}/pdf`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * @description Получение списка статусов реестра на перечисление зп
     *
     * @tags Реестр на перечисление зп
     * @name GetRegistryHistory
     * @summary Получить историю реестра
     * @request GET:/api/salary-transfer/external/v1/registry/{registryId}/history
     * @secure
     */
    getRegistryHistory: (registryId: string, params: RequestParams = {}) =>
      this.request<RegistryHistoryList, DefaultExceptionResponse>({
        path: `/api/salary-transfer/external/v1/registry/${registryId}/history`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Подписание реестров
     * @name GetCcbString
     * @summary Эндпоинт для получения строки ККБ. Проксирует запрос в МС Подтверждения
     * @request GET:/api/salary-transfer/external/v1/registry/{registryId}/build-ccb
     * @secure
     */
    getCcbString: (registryId: string, params: RequestParams = {}) =>
      this.request<string, DefaultExceptionResponse>({
        path: `/api/salary-transfer/external/v1/registry/${registryId}/build-ccb`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * @description Экспорт нескольких реестров на перечисление зарплаты в виде архива Excel-файлов
     *
     * @tags Реестр на перечисление зп, Экспорт реестров на перечисление зп
     * @name DownloadExcels
     * @summary Экспорт нескольких Excel-файлов
     * @request GET:/api/salary-transfer/external/v1/registry/export/xls
     * @secure
     */
    downloadExcels: (
      query: { registryId: string[] },
      params: RequestParams = {}
    ) =>
      this.request<string, DefaultExceptionResponse>({
        path: `/api/salary-transfer/external/v1/registry/export/xls`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Экспорт нескольких реестров на перечисление зарплаты в виде архива PDF-файлов
     *
     * @tags Реестр на перечисление зп, Экспорт реестров на перечисление зп
     * @name DownloadPdfs
     * @summary Экспорт нескольких PDF-файлов
     * @request GET:/api/salary-transfer/external/v1/registry/export/pdf
     * @secure
     */
    downloadPdfs: (
      query: { registryId: string[] },
      params: RequestParams = {}
    ) =>
      this.request<string, DefaultExceptionResponse>({
        path: `/api/salary-transfer/external/v1/registry/export/pdf`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Получение списка существующих реестров на перечисление зп с фильтрацией
     *
     * @tags Реестр на перечисление зп
     * @name GetRegistryList
     * @summary Получить список реестров
     * @request GET:/api/salary-transfer/external/v1/contract/{contractAbsId}/registry
     * @secure
     */
    getRegistryList: (
      contractAbsId: string,
      query?: {
        prompt?: string;
        statusList?: string[];
        registryFrom?: string;
        registryTill?: string;
        position?: number;
        size?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<SlicedRegistryList, DefaultExceptionResponse>({
        path: `/api/salary-transfer/external/v1/contract/${contractAbsId}/registry`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Получение номера для создания нового реестра на перечисление зп
     *
     * @tags Реестр на перечисление зп
     * @name GetNextRegistryNumber
     * @summary Получить следующий номер реестра
     * @request GET:/api/salary-transfer/external/v1/contract/{contractAbsId}/next-registry-number
     * @secure
     */
    getNextRegistryNumber: (
      contractAbsId: string,
      params: RequestParams = {}
    ) =>
      this.request<string, DefaultExceptionResponse>({
        path: `/api/salary-transfer/external/v1/contract/${contractAbsId}/next-registry-number`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Реестр на перечисление зп
     * @name CountWaitingSign
     * @summary Эндпоинт для получения числа реестров на перечисление зп, ожидающих подписания.
     * @request GET:/api/salary-transfer/external/v1/contract/{contractAbsId}/count-unsigned
     * @secure
     */
    countWaitingSign: (
      contractAbsId: string,
      query?: { beginDate?: string; endDate?: string },
      params: RequestParams = {}
    ) =>
      this.request<string, DefaultExceptionResponse>({
        path: `/api/salary-transfer/external/v1/contract/${contractAbsId}/count-unsigned`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Получение типов подтверждения подписи для текущего клиента (ЮЛ)
     *
     * @tags Подписание реестров
     * @name GetConfirmationType
     * @summary Get confirmation type for current client
     * @request GET:/api/salary-transfer/external/v1/confirm-types
     * @secure
     */
    getConfirmationType: (params: RequestParams = {}) =>
      this.request<ConfirmationTypeList, DefaultExceptionResponse>({
        path: `/api/salary-transfer/external/v1/confirm-types`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}

export const api = new Api();
